import React, { useMemo } from 'react';
import { string, func, bool } from 'prop-types';

import classnames from 'classnames';
import DOMpurify from 'isomorphic-dompurify';

import { namespace, maxLength } from '../constants';
import LabelBuilder from '../../label-builder';

/**
 * Componente para renderizar la descripción de un cuadro de texto con funcionalidad de expandir/colapsar.
 * @param {Object} props - Props del componente.
 * @param {string} props.see_less - Texto para el botón "ver menos".
 * @param {string} props.see_more - Texto para el botón "ver más".
 * @param {Function} props.handleClick - Función para manejar el evento de clic en el botón.
 * @param {boolean} props.collapsed - Indica si el texto está colapsado.
 * @param {string} props.description - Descripción que se muestra en el cuadro de texto.
 * @returns {React.Element} Componente InfoTextBoxDescription.
 */
const InfoTextBoxDescription = ({ see_less, see_more, handleClick, collapsed, description }) => {
  const isLongText = useMemo(() => description?.length >= maxLength, [description]);
  const labelBuilderValues = [
    {
      text: collapsed ? see_more : see_less,
      key: 'button_text',
      type: 'text',
    },
    {
      key: 'button_icon',
      type: 'ICON',
      icon_id: 'chevron',
      description: 'Icono chevron',
      className: `${namespace}__button-icon`,
    },
  ];

  return (
    <>
      <div
        className={classnames(`${namespace}__details`, {
          [`${namespace}__details--is-collapsed`]: collapsed && isLongText,
        })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description ? DOMpurify.sanitize(description) : '' }}
      />
      {isLongText && (
        <button
          className={classnames(`${namespace}__button`, { [`${namespace}__button--is-collapsed`]: collapsed })}
          onClick={handleClick}
          type="button"
        >
          <LabelBuilder text="{button_text} {button_icon}" id="button_toggle" values={labelBuilderValues} />
        </button>
      )}
    </>
  );
};

InfoTextBoxDescription.propTypes = {
  collapsed: bool.isRequired,
  description: string.isRequired,
  handleClick: func.isRequired,
  see_less: string.isRequired,
  see_more: string.isRequired,
};

export default InfoTextBoxDescription;
